import type { Payout } from '@packages/domain/models/payout';
import { SET_PAYOUTS } from 'constants/payouts';

type PayoutsAction = {
  type: typeof SET_PAYOUTS;
  payload: Payout[];
};

const payouts = (state: Payout[] = [], action: PayoutsAction) => {
  switch (action.type) {
    case SET_PAYOUTS:
      const { payload: payouts } = action;

      return payouts;
    default:
      return state;
  }
};

export { payouts };
